function toRoman(num: number): string {
  if (num <= 0) return "";
  const roman = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 };
  let str = '';
  for (const i of Object.keys(roman) as Array<keyof typeof roman>) {
    const q = Math.floor(num / roman[i]);
    num -= q * roman[i];
    str += i.repeat(q);
  }
  return str;
}

function toAlpha(num: number, isLower: boolean): string {
  let str = "";
  while (num >= 0) {
    str = String.fromCharCode((num % 26) + (isLower ? 97 : 65)) + str;
    num = Math.floor(num / 26) - 1;
  }
  return str;
}

export function getNumeration(depth: number, index: number): string {
  const n = index + 1;
  switch (depth) {
    case 0: return toRoman(n) + "."; // I, II, III...
    case 1: return toAlpha(index, false) + "."; // A, B, C...
    case 2: return n.toString() + "."; // 1, 2, 3...
    case 3: return toAlpha(index, true) + "."; // a, b, c...
    case 4: return toRoman(n).toLowerCase() + "."; // i, ii, iii...
    default: return n.toString() + ".";
  }
}
